import { EVV_FALLBACK_REASON_LABELS, EVV_FALLBACK_REASONS } from '../../../../constants';

export const EVV_QR_SCAN_TIMEOUT_SECONDS = 90;

export const EVV_FALLBACK_REASON_OPTIONS = Object.values(EVV_FALLBACK_REASONS).map((value) => ({
  value,
  label: EVV_FALLBACK_REASON_LABELS[value],
}));
